import { z } from 'zod';
import { isCalendarDate } from './people.js';

const calendarDateSchema = z.string().refine(isCalendarDate);

/**
 * Starts a club membership. The interval is inclusive; the start defaults to the club's current
 * day. Club membership is independent of team placement, group placement and competition
 * registration.
 */
export const joinClubRequestSchema = z
  .strictObject({
    joinedOn: calendarDateSchema.optional(),
    leftOn: calendarDateSchema.nullable().default(null),
  })
  .refine(
    (request) =>
      request.joinedOn === undefined ||
      request.leftOn === null ||
      request.leftOn >= request.joinedOn,
  );
export type JoinClubRequest = z.infer<typeof joinClubRequestSchema>;

/** Ends an open membership on the given day (default: the club's current day); history is kept. */
export const leaveClubRequestSchema = z.strictObject({
  leftOn: calendarDateSchema.optional(),
});
export type LeaveClubRequest = z.infer<typeof leaveClubRequestSchema>;

/** One period of club membership; calendar days are `YYYY-MM-DD`. */
export interface ClubMembershipView {
  id: string;
  athleteId: string;
  joinedOn: string;
  leftOn: string | null;
  /** Row version; send it in `If-Match` when ending the membership. */
  version: number;
}
